import gql from 'graphql-tag'
import client from '@stores/apollo'
import { parseContract } from '.'
import { ILease } from '@api'
import { LeaseFragment } from '@api/fragments'

interface IPayload {
  data: {
    contract: any
  }
}

export default function details(id: string): Promise<ILease> {
  const variables = { id }

  return client.gql
    .query({ query, variables })
    .then(({ data: { contract } }: IPayload) => parseContract(contract))
}

const query = gql`
  query Contract($id: ID!) {
    contract: node(id: $id) {
      ...LeaseFragment
    }
  }
  ${LeaseFragment}
`
